/* eslint-disable unicorn/filename-case */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TWIAResourcesService {
    static getPCPortalConstants(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('constants'),
            'getPCPortalConstants',
            [],
            additionalHeaders
        );
    }

    // 2025-02-01 - Debra Frum - US25432 - CE - Policy Holds
    static getPortalBannerTWIA(bannerType, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('constants'),
            'getPortalBanner_TWIA',
            [bannerType],
            additionalHeaders
        );
    }
}
